module.exports = __webpack_public_path__ + "static/media/bluesapphero.a6dfc1b9.jpg";